import { defineMessages } from 'react-intl';

const profileDeactivatedMessages = defineMessages({
  returnToSignInButton: {
    id: 'profileDeactivated.returnToSignInButton',
    defaultMessage: 'Return to sign in',
    description: 'Button to return to sign in page',
  },
  containerTitle: {
    id: 'profileDeactivated.containerTitle',
    defaultMessage: 'Profile removed',
    description: 'Profile has been removed title',
  },
  description: {
    id: 'profileDeactivated.description',
    defaultMessage:
      'You no longer have a profile with this organization. Contact your learning admin to get a new invitation.',
    description: 'Profile has been removed description',
  },
  personalBuilderIdRecommendation: {
    id: 'profileDeactivated.personalBuilderIdRecommendation',
    defaultMessage:
      'To take training by using an individual account, sign in or sign up with your personal AWS Builder ID.',
    description:
      'If you want to take training on your own, you can sign in or sign up using your personal AWS Builder ID.',
  },
});

export default profileDeactivatedMessages;
